import { useCallback, useState } from "react";
import { importPlayers, importTeams } from "../../../api/index.js";
import ImportCSV from "./ImportCSV.js";
import { CircularProgress, Typography } from "@mui/material";

const TeamsCSV = () => {
    const [loading, setLoading] = useState(false);
    const [importComplete, setImportComplete] = useState(false);
    const [response, setResponse] = useState([]);

    const handleTeamImport = useCallback( async (rows) => {
        setLoading(true);

        try {
            const {data} = await importTeams(rows);
            setResponse(s => s.concat([data.message]));
        } catch (error) {
            console.error(error);
            setResponse(error.message);
        } finally {
          setLoading(false);
        }
    }, [])

    const handleImportComplete = () => {
      // Set importComplete after the entire import is complete
      setImportComplete(true);
  };


    return <div>
      <Typography variant="h2">Equipes</Typography>
    <ImportCSV
      columns={[
        { id: 'name', label: 'Nom' },
        { id: 'discipline', label: 'Discipline' },
        { id: 'provider', label: 'Groupe' },
        { id: 'competitionSeason', label: 'Saison de la competition' },

        { id: 'competitionName', label: 'Competition', optional : true },
        
        { id: 'idTeam', label: 'team_id', optional : true },
        { id: 'idCompetition', label: 'competition_id', optional : true },
        { id: 'thirdParty', label: 'thirdParty', optional : true },

        { id: 'fullName', label: 'Nom complet', optional : true },
        { id: 'color', label: 'Couleur domicile', optional : true },
        { id: 'awayColor', label: 'Couleur extérieur', optional : true },
        { id: 'isCountry', label: 'Equipe nationale', optional : true },
        { id: 'country', label: 'Pays', optional : true },
        { id: 'stadiumName', label: 'Stade', optional : true },
        { id: 'stadiumCapacity', label: 'Capacité du stade', optional : true },
        { id: 'teamCreation', label: 'Année de création', optional : true },
        { id: 'website', label: 'Site web', optional : true },
        { id: 'president', label: 'Président', optional : true },
        { id: 'coaches', label: 'Entraineurs', optional : true },
        { id: 'subscription', label: 'Souscription live', optional : true },

      ]}
      onComplete={handleImportComplete}
      process={handleTeamImport}
    />

    {loading && <CircularProgress />}
    {importComplete && response.length && response.map((r, index) => <p key={index}>{r}</p>)}
  </div>
}

export default TeamsCSV